import ActionButton from 'components/ActionButton';
import React, { useState } from 'react';
import styles from './index.module.scss';
import _ from 'lodash';
import { USER_ROLES, isUserAuthorized } from 'utils';

const SEOFields = props => {
  const isUserAuthorizedToEdit = isUserAuthorized(props.userRoles, [USER_ROLES.PACKER, USER_ROLES.SUPERVISOR, USER_ROLES.MANAGER, USER_ROLES.ADMIN]);
  const [editFields, setEditFields] = useState<boolean>(false);
  const {
    updatedItem,
    handleEditCancel,
    inventoryItem,
    loading,
    setUpdatedItem,
    updateInventoryItemDetails,
  } = props;

  const handleEdit = (key: string, value: string) => {
    setUpdatedItem({
      ...updatedItem,
      [key]: value,
    });
  };
  
  const handleEditCancelFn = () => {
    handleEditCancel(_.pick(inventoryItem, [
      'name',
      'description',
      'englishName',
      'englishDescription',
    ]));
    setEditFields(false);
  };

  const handlePrimaryAction = async () => {
    if (editFields) {
      await updateInventoryItemDetails();
    // } else {
    }
    setEditFields(!editFields);
  };

  const SEOGroup = (
    { label, detail = '', isTextArea = false, propertyKey }:
      { label: string; detail: string; isTextArea?: boolean; propertyKey: string },
  ) => (
    <div className={styles['seo-group']}>
      <div className={styles['label']}>{label}</div>
      {editFields ? (
        isTextArea ? (
          <textarea
            key={propertyKey}
            disabled={loading}
            className={'form-control'}
            value={detail}
            onChange={e => handleEdit(propertyKey, e.target.value)}
          />
        ) : (
          <input
            key={propertyKey}
            disabled={loading}
            className={'form-control'}
            value={detail}
            onChange={e => handleEdit(propertyKey, e.target.value)}
          />
        )
      ) : (
        <div className={styles['info']}>{detail || '-'}</div>
      )}
    </div>
  );

  return (
    <div className={styles['seo-section-container']}>
      <div className={styles['section-header']}>
        <div className={styles['section-heading']}>SEO Fields</div>
        <div className={'d-flex'}>
          {isUserAuthorizedToEdit && <ActionButton
            text={editFields ? 'Save' : 'Edit'}
            active={true}
            isLoading={false}
            onClick={handlePrimaryAction}
          />}
          {editFields && (
            <ActionButton
              text={'Cancel'}
              active={true}
              isLoading={false}
              onClick={handleEditCancelFn}
              customClass={styles['cancel-button']}
            />
          )}
        </div>
      </div>
      <div className={styles['seo-fields-section']}>
        {SEOGroup({
          detail: updatedItem.name,
          label: 'Spanish Name',
          propertyKey: 'name',
        })}
        {SEOGroup({
          detail: updatedItem.enName,
          label: 'English Name',
          propertyKey: 'enName',
        })}
        {SEOGroup({
          detail: updatedItem.description,
          label: 'Spanish Description',
          propertyKey: 'description',
          isTextArea: true,
        })}
        {SEOGroup({
          detail: updatedItem.enDescription,
          label: 'English Description',
          propertyKey: 'enDescription',
          isTextArea: true,
        })}
      </div>
    </div>
  );
};

export default SEOFields;